import React from 'react';
import { EBankTransactionProcessingStatus } from '../types';

interface ITransactionStatusCellProps {
  status: EBankTransactionProcessingStatus;
}

const statusConfig: Record<EBankTransactionProcessingStatus, { label: string; className: string }> = {
  [EBankTransactionProcessingStatus.ACTION_REQUIRED]: {
    label: 'Action Required',
    className: 'text-red-90',
  },
  [EBankTransactionProcessingStatus.READY_TO_PROCESS]: {
    label: 'Ready To Process',
    className: 'text-yellow-60',
  },
  [EBankTransactionProcessingStatus.IN_PROGRESS]: {
    label: 'In Progress',
    className: 'text-status-enquiry',
  },
  [EBankTransactionProcessingStatus.PROCESSED]: {
    label: 'Processed',
    className: 'text-status-confirmed',
  },
};

const fallbackConfig = { label: 'Unknown', className: 'text-gray-100' };

export const TransactionStatusCell: React.FC<ITransactionStatusCellProps> = ({ status }) => {
  const config = statusConfig[status] ?? fallbackConfig;
  return <span className={`font-medium ${config.className}`}>{config.label}</span>;
};
